// Helpers for the signed lead token from /wp-json/api/v1/email-marketing/session.
//
// Keep this file identical in V4, V5 and V6 (V7 has a typed copy).
// V4/src/func/leadToken.test.js checks that the copies match.

// The server accepts a token for 24h. Fetch a new one well before that.
export const TOKEN_MAX_AGE_MS = 12 * 60 * 60 * 1000;

// Extra wait on top of the server's minimum, so a lead never arrives early.
export const SEND_DELAY_MARGIN_MS = 500;

export const isTokenStale = (token, receivedAt, now = Date.now()) =>
  !token || !Number.isFinite(receivedAt) || now - receivedAt >= TOKEN_MAX_AGE_MS;

// How long to wait before sending a lead. The server rejects leads that come
// sooner than minDelayMs after /session, which only scripts manage, but fast
// autofill can blur the email field that quickly too.
export const getLeadSendDelay = (minDelayMs, receivedAt, now = Date.now()) => {
  if (!(minDelayMs > 0) || !Number.isFinite(receivedAt)) return 0;

  return Math.max(0, minDelayMs + SEND_DELAY_MARGIN_MS - (now - receivedAt));
};
